import { type FC } from 'react';
import { selectWorkshopUpgradeData } from '@redux/selectors/workshopSelectors';
import { useAppSelector } from '@redux/store';

import { type WorkshopUpgradeItemAll } from '@/common/types/components';

import { CompaireItem } from './CompaireItem';

interface WorkshopUpgradeInfoProps {
  id?: string;
  data?: WorkshopUpgradeItemAll;
}

const WorkshopUpgradeInfo: FC<WorkshopUpgradeInfoProps> = ({ id, data }) => {
  const compaireOptions = useAppSelector((state) =>
    selectWorkshopUpgradeData(state, id),
  );

  const loadCompare = data?.load || compaireOptions?.load;

  return (
    <div className="w-full flex flex-col gap-1 mt-4 mb-6">
      {loadCompare && (
        <CompaireItem
          key={loadCompare.kind}
          kind={loadCompare.kind}
          now={loadCompare.now}
          next={loadCompare.next}
        />
      )}
      {(data || compaireOptions)?.result.map((item) => (
        <CompaireItem
          key={item.goodsName}
          goodsName={item.goodsName}
          now={item.now}
          next={item.next}
        />
      ))}
    </div>
  );
};

export { WorkshopUpgradeInfo };
